import * as XLSX from "xlsx";

//Helper function for creating and downloading Excel using Headers
export const GenerateTermDateTemplateExcel = async (TemplateHeaders) => {
        // Create a worksheet using the headers
        const worksheet = XLSX.utils.aoa_to_sheet([TemplateHeaders]);

        // Create a new workbook and add the worksheet to it
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    
        // Convert the workbook to a buffer (binary data)
        const excelBuffer = XLSX.write(workbook, { type: "buffer" });
    
        // Create a Blob (binary large object) from the buffer
        const blob = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
    
        // Create a download link and trigger the download
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = "TermDateTemplate.xlsx"; // The file will be downloaded with this name
        downloadLink.click();
}